import { Injectable } from '@angular/core';
import { EncryptService } from './encrypt.service';
import { ACTIVE_ORGANISATION_ID_KEY } from '../constants/common-enum';

@Injectable({
  providedIn: 'root'
})
export class ActiveOrganisationService {
  private encryptedOrganisationId: string | null = null;

  constructor(private encryptService: EncryptService) { }

  async initialize(): Promise<void> {
    this.encryptedOrganisationId = localStorage.getItem(ACTIVE_ORGANISATION_ID_KEY);
  }

  async setActiveOrganisationId(organisationId: number | null): Promise<void> {
    if (organisationId == null) {
      this.clear();
      return;
    }

    const encrypted = await this.encryptService.encrypt(organisationId);
    this.encryptedOrganisationId = encrypted;
    localStorage.setItem(ACTIVE_ORGANISATION_ID_KEY, encrypted);
  }

  getEncryptedOrganisationId(): string | null {
    return this.encryptedOrganisationId;
  }

  clear(): void {
    localStorage.removeItem(ACTIVE_ORGANISATION_ID_KEY);
    this.encryptedOrganisationId = null;
  }
}
